import React, { useEffect } from 'react'

function ProgressBar( props ) {
    useEffect(() => {
        // console.log(props);
    }, []);

    return (
        <div className="timeline-progress-bar">
            {props.years && props.years.map((y) => (
                <span
                    key={y}
                    className={y === props.currentYear ? 'current' : ( y < props.currentYear ? 'past' : 'future')}
                >{y}
                </span>
            ))}
        </div>
    );
}

export default ProgressBar;
